import { NUMBER } from "../../constants/app-constants";

export default (name, minLength = 0, maxLength = NUMBER.HUNDRED) => {
    const nameRegex = new RegExp(`^[a-zA-Z.' ]*[a-zA-Z.']{${minLength},${maxLength}}$`);
    const isValid = nameRegex.test(String(name).toLowerCase());
    return isValid;
};
